import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'normalize.css'

const app = createApp(App)
app.config.compilerOptions.isCustomElement = (tag) => tag === 'wx-open-launch-weapp'
app.use(store).use(router).mount('#app')